import { useKeycloak } from '@react-keycloak/web';
import axios from 'axios';
import { useEffect, useState } from 'react';

const config = window.CONFIG;
const BASE_SERVICE = '/exportafacil_backend/rest/';
const URL_SERVER_PROD = 'https://vueapp.vue.gov.py';
const URL_SERVER_TEST = 'https://vueapp.test.vue.gov.py';
const URL_SERVER_LOCAL = 'http://localhost:8080';

const BASE_URL =
  // eslint-disable-next-line no-nested-ternary
  process.env.REACT_APP_PROFILE === 'prod'
    ? URL_SERVER_PROD
    : process.env.REACT_APP_PROFILE === 'test'
      ? URL_SERVER_TEST
      : URL_SERVER_LOCAL;

const instance = axios.create({
  baseURL: BASE_URL + BASE_SERVICE,
  headers: { 'Content-Type': 'application/json' },
  data: {}
});

const useAxios = baseURL => {
  const [keycloak, initialized] = useKeycloak();
  const [axiosInstance, setAxiosInstance] = useState({});

  useEffect(
    () => {
      const instanceAxiosKeycloak = axios.create({
        baseURL: baseURL || `${config.serverUrl}${config.serverContext}`,
        timeout: 1500000,
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          Authorization: initialized ? `Bearer ${keycloak.token}` : undefined
        }
      });
      instanceAxiosKeycloak.CancelToken = axios.CancelToken;
      instanceAxiosKeycloak.isCancel = axios.isCancel;

      setAxiosInstance({ instance: instanceAxiosKeycloak });

      return () => {
        setAxiosInstance({});
      };
    },
    [baseURL, initialized, keycloak, keycloak.token]
  );

  return axiosInstance.instance;
};

const setupAxios = () => {
  const token = localStorage.getItem(config.localStorageKey);

  // Headers con el bearer
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};

const clearToken = () => {
  delete instance.defaults.headers.common.Authorization;
};

export default instance;
export { clearToken, setupAxios, useAxios };
